// InviteFriendTable.jsx
import React from "react";
import MobilePaginatorElement from "../../atoms/MobilePaginatorElement";
import DesktopInvitePaginatorElement from "../../atoms/DesktopInvitePaginatorElement";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import useTranslate from "../../../hooks/useTranslate";
import useFormatNumber from "../../../hooks/useFormatNumber";
import "./styles.sass";

const PER_PAGE = 5;

const InviteFriendTable = ({
  listReferral,
  currentPage,
  lastPage,
  total,
  onPageChange,
}) => {
  const { isDesktop } = useBreakpoint();
  const t = useTranslate();
  const FormatNumber = useFormatNumber();
  const safeCurrentPage = Math.min(currentPage, lastPage);

  const handlePageClick = (selectedItem) => {
    const newPage = selectedItem.selected + 1;
    if (newPage <= lastPage) {
      onPageChange(selectedItem);
    }
  };

  const formatID = (id) => `${id.substring(0, 3)}*****`;
  const title = listReferral.length
    ? t("referral.invited")
    : t("referral.nothing");
  // eslint-disable-next-line no-console
  console.log("InviteFriendTable_listReferral", listReferral);
  return (
    <div className={`InviteFriendTable ${isDesktop ? "desktop" : "mobile"}`}>
      <span className="InviteFriendTable__title">{title}</span>
      <div className="table-container">
        <table>
          <thead>
            <tr className="InviteFriendTable-th">
              <th>No</th>
              <th>ID</th>
              <th>{t("referral.link.profit")}</th>
            </tr>
          </thead>
          <tbody>
            {listReferral.map((row, index) => (
              <tr key={row.referralId} className="InviteFriendTable-tr">
                <td className="InviteFriendTable-tr__value">
                  {(safeCurrentPage - 1) * 5 + index + 1}
                </td>
                <td className="InviteFriendTable-tr__value">
                  {formatID(row.referralId.toString())}
                </td>
                <td className="InviteFriendTable-tr__value">
                  {FormatNumber(row.profit, 2, false, "", true)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {total > PER_PAGE &&
        (isDesktop ? (
          <DesktopInvitePaginatorElement
            currentPage={currentPage}
            lastPage={lastPage}
            onClick={handlePageClick}
          />
        ) : (
          <MobilePaginatorElement
            currentPage={currentPage}
            lastPage={lastPage}
            onClick={handlePageClick}
          />
        ))}
    </div>
  );
};

export default InviteFriendTable;
